<template>
  <div>
    <p class="t3 -t_medium -my_0 subtitle">
      {{
        $t("PHASE_OUT_OF", {
          currentPhase: currentPhase,
          totalPhases: totalPhases,
        })
      }}
      <span class="dot-separator separator"></span>
      <span class="subtitle">{{ startDate }} - </span>
      <span :class="{ outdated: outdated, date: !outdated }">{{ endDate }}</span>
    </p>
    <p class="-t_medium -my_0">{{ $t(name) }}</p>
  </div>
</template>

<script>
export default {
  name: 'PhaseInfoCell',
  props: {
    currentPhase: {
      type: Number,
      required: true,
    },
    totalPhases: {
      type: Number,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    outdated: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.separator {
  margin: 0 0.375rem 0.2rem;
}

.outdated {
  color: $negative-color;
}

.subtitle {
  color: $context-color-4;
}
</style>
